<template>
    <div class="hello">
        <el-tabs type="border-card">
            <el-tab-pane label="登陆">
                <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
                    <el-form-item label="内控账号">
                        <el-input v-model="loginform.username"></el-input>
                    </el-form-item>
                    <el-form-item label="内控密码">
                        <el-input type="password" v-model="loginform.password"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="login()">登陆</el-button>
                    </el-form-item>
                </el-form>
            </el-tab-pane>
            <el-tab-pane label="签到打卡">
                <el-container>
                    <el-header height="220px">
                        <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
                            <el-form-item label="经度">
                                <el-input v-model="dakaform.lng"></el-input>
                            </el-form-item>
                            <el-form-item label="纬度">
                                <el-input v-model="dakaform.lat"></el-input>
                            </el-form-item>
                            <el-form-item label="地址">
                                <el-input v-model="dakaform.addr"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="shoujidaka()">上班</el-button>
                                <el-button type="primary" @click="shoujidaka()">下班</el-button>
                            </el-form-item>
                        </el-form>
                    </el-header>
                    <el-main>
                        <baidu-map class="bm-view"
                                   :center="center"
                                   :zoom="zoom"
                                   :scroll-wheel-zoom="true"
                                   @moving="syncCenterAndZoom"
                                   @moveend="syncCenterAndZoom"
                                   @zoomend="syncCenterAndZoom"
                                   @click="mapclick"
                                   ak="vAEpdIVegXXzBGGOBFb0LGQHs1CG0YA0">
                        </baidu-map>
                    </el-main>
                </el-container>
            </el-tab-pane>
            <el-tab-pane label="外出打卡">
                <el-container>
                    <el-header height="340px">
                        <el-form :label-position="labelPosition" label-width="80px" :model="formLabelAlign">
                            <el-form-item label="外出类型">
                                <el-radio v-model="waichuform.radio" label="1">公出（本市）</el-radio>
                                <el-radio v-model="waichuform.radio" label="2">出差（外市）</el-radio>
                            </el-form-item>
                            <el-form-item label="经度">
                                <el-input v-model="waichuform.lng"></el-input>
                            </el-form-item>
                            <el-form-item label="纬度">
                                <el-input v-model="waichuform.lat"></el-input>
                            </el-form-item>
                            <el-form-item label="地址">
                                <el-input v-model="waichuform.addr"></el-input>
                            </el-form-item>
                            <el-form-item label="事由">
                                <el-input v-model="waichuform.shiyou"></el-input>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" @click="waichudaka()">打卡</el-button>
                            </el-form-item>
                        </el-form>
                    </el-header>
                    <el-main>
                        <baidu-map class="bm-view"
                                   :center="center"
                                   :zoom="zoom"
                                   :scroll-wheel-zoom="true"
                                   @moving="syncCenterAndZoom"
                                   @moveend="syncCenterAndZoom"
                                   @zoomend="syncCenterAndZoom"
                                   @click="mapclick_waichu"
                                   ak="vAEpdIVegXXzBGGOBFb0LGQHs1CG0YA0">
                        </baidu-map>
                    </el-main>
                </el-container>
            </el-tab-pane>
            <el-tab-pane label="定时任务">
                定时自动打卡任务，暂未开放。本项目仅供学习使用，请自行编码实现。
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import Vue from 'vue'
    import axios from 'axios';

    export default {
        data() {
            return {
                labelPosition: 'right',
                formLabelAlign: {
                    name: '',
                    region: '',
                    type: '',
                    redme: false
                },
                loginform: {
                    username: '',
                    password: ''
                },
                dakaform: {
                    lng: 116.372437,
                    lat: 39.992007,
                    addr: '北京市海淀区花园路塔院2号'
                },
                waichuform: {
                    radio: '1',
                    lng: 116.372437,
                    lat: 39.992007,
                    addr: '北京市海淀区花园路塔院2号',
                    shiyou: ''
                },
                center: {lng: 116.372437, lat: 39.992007},
                zoom: 17
            };
        },
        methods: {
            login(){
                var url = "http://wukong-api.renfei.net/api/WebRoot/AppLoginAction.do?callback=doLogin&userId=";
                url += encodeURIComponent(this.loginform.username);
                url += "&password=";
                url += encodeURIComponent(this.loginform.password);
                url += "&activity=login&callback=jsonp&CID=&PUSHCID=&isMobile=y";
                axios.get(url)
                    .then(function (response) {
                        if (response.status == 200) {
                            var data = response.data;
                            if (data.indexOf('{"isSuccess":"false"}') == -1) {
                                Vue.prototype.$message({
                                    message: '登陆成功！你可以去使用其他功能了',
                                    type: 'success'
                                });
                            } else {
                                Vue.prototype.$message({
                                    message: '账号或密码错误，登陆失败',
                                    type: 'warning'
                                });
                            }
                        } else {
                            Vue.prototype.$message.error('请求发生错误');
                        }

                    })
                    .catch(function (error) {
                        Vue.prototype.$message.error('请求发生错误' + error);
                    });
            },
            syncCenterAndZoom (e) {
                const {lng, lat} = e.target.getCenter()
                this.center.lng = lng
                this.center.lat = lat
                this.zoom = e.target.getZoom()
            },
            mapclick(e){
                this.dakaform.lng = e.point.lng;     //通过  e.point.lng获取经度
                this.dakaform.lat = e.point.lat;     //通过  e.point.lat获取纬度
                let geocoder = new BMap.Geocoder();  //创建地址解析器的实例
                geocoder.getLocation(e.point, rs => {
                    this.dakaform.addr = rs.address;
//                    console.log(rs.address);
                });
            },
            mapclick_waichu(e){
                this.waichuform.lng = e.point.lng;     //通过  e.point.lng获取经度
                this.waichuform.lat = e.point.lat;     //通过  e.point.lat获取纬度
                let geocoder = new BMap.Geocoder();  //创建地址解析器的实例
                geocoder.getLocation(e.point, rs => {
                    this.waichuform.addr = rs.address;
//                    console.log(rs.address);
                });
            },
            shoujidaka(){
                this.daka(
                    this.dakaform.lat,
                    this.dakaform.lng,
                    this.dakaform.addr, '', '');
            },
            waichudaka(){
                this.daka(
                    this.waichuform.lat,
                    this.waichuform.lng,
                    this.waichuform.addr,
                    this.waichuform.radio,
                    this.waichuform.shiyou);
            },
            daka(lat, lng, addr, type, remark){
                var url = "http://wukong-api.renfei.net/api/WebRoot/AppSigninAction.do?latitude=";
                url += lat;
                url += "&longitude=";
                url += lng;
                url += "&addr=";
                url += addr;
                url += "&remark=";
                url += remark;
                url += "&type=";
                url += type;
                axios.get(url)
                    .then(function (response) {
                        if (response.status == 200) {
                            var data = response.data;
                            if (data.isSuccess) {
                              if(data.isLeave){
                                Vue.prototype.$message({
                                  message: '成功！',
                                  type: 'success'
                                });
                              }else {
                                Vue.prototype.$message({
                                  message: '请核实是否具有签到权限、是否已经销假',
                                  type: 'warning'
                                });
                              }
                            } else {
                                Vue.prototype.$message({
                                    message: '失败！',
                                    type: 'warning'
                                });
                            }
                        } else {
                            Vue.prototype.$message.error('请求发生错误');
                        }

                    })
                    .catch(function (error) {
                        Vue.prototype.$message.error('你可能还没有登录，先登录再尝试打卡');
                    });
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    .hello {
        height: 100%;
    }

    .bm-view {
        width: 100%;
        height: 300px;
    }
</style>



// WEBPACK FOOTER //
// src/components/HelloWorld.vue